const KEY_MAP = {
  ARROW_DOWN: 'ArrowDown',
  ARROW_RIGHT: 'ArrowRight',
  ARROW_UP: 'ArrowUp',
  ARROW_LEFT: 'ArrowLeft',
  TAB: 'Tab'
};
const tabPressed = e => !e.shiftKey && (e.key === KEY_MAP.TAB || e.code === KEY_MAP.TAB);
const shiftTabPressed = e => e.shiftKey && (e.key === KEY_MAP.TAB || e.code === KEY_MAP.TAB);

export { KEY_MAP, shiftTabPressed, tabPressed };
